/* eslint no-bitwise: 0 */
export function LightenDarkenColor(col: string, amt: number): string {
  let usePound = false
  if (col[0] === '#') {
    col = col.slice(1)
    usePound = true
  }
  const num = parseInt(col, 16)

  let r = (num >> 16) + amt
  if (r > 255) r = 255
  else if (r < 0) r = 0

  let g = ((num >> 8) & 0x00FF) + amt
  if (g > 255) g = 255
  else if (g < 0) g = 0

  let b = (num & 0x0000FF) + amt
  if (b > 255) b = 255
  else if (b < 0) b = 0

  return (usePound ? '#' : '') + (b | (g << 8) | (r << 16)).toString(16).padStart(6, '0')
}

export function brightness(color: string): number {
  if (color[0] === '#') {
    color = color.slice(1)
  }

  const num = parseInt(color, 16)
  const r = (num >> 16)
  const g = ((num >> 8) & 0x00FF)
  const b = (num & 0x0000FF)

  return (r * 299 + g * 587 + b * 114) / 1000
}

export function isColorHex(hex: string): boolean {
  const regex = RegExp('^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$')
  return regex.test(hex)
}
